import type { ComponentProps } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Button } from './button';

export type IconButtonProps = Omit<ComponentProps<typeof Button>, 'children' | 'size'> & {
  icon: LucideIcon;
  /** Accessible name and tooltip (translated): an icon-only button always has one. */
  label: string;
  size?: 'icon' | 'icon-sm';
};

/** Icon-only button (ghost by default), always named for screen readers. */
export function IconButton({
  icon: Icon,
  label,
  variant = 'ghost',
  size = 'icon-sm',
  title,
  ...props
}: IconButtonProps) {
  return (
    <Button variant={variant} size={size} aria-label={label} title={title ?? label} {...props}>
      <Icon aria-hidden />
    </Button>
  );
}
